export default function (context, val) {
    let form = context.state.form;
    context.dispatch('set_title', 'Редактирование счета №' + val.id, {root: true});
    context.dispatch('invoices/get', {
        id: val.id,
        callback: (invoice) => {
            context.state.system.manager = invoice.data.Manager ? invoice.data.Manager : '';
            context.state.system.manager = invoice.data.PaySystemDocumentNumber ? invoice.data.PaySystemType : '';
            context.state.system.createDate = invoice.data.CreatedDate ? invoice.data.CreatedDate.Serialized : '';
            context.commit('set_form', invoice.form);
            context.state.options.legals = invoice.legals;
            context.commit('set_load', {
                data: false,
            });
        }
    });
    context.dispatch('files/get', val.id);
}
